let _lazyloadCache = {};
function lazyload ($domElement) {
    if (!$domElement.hasClass('js-lazyload')) {
        return new Promise(function (resolve, reject) { resolve(''); });
    }
    let url = $domElement.data('lazyurl');
    if (!url) {
        return new Promise(function (resolve, reject) { reject(new Error('data-lazyurl not provided')); });
    }
    if (_lazyloadCache[url]) {
        return new Promise(function (resolve, reject) { resolve(_lazyloadCache[url]); });
    }
    return $.ajax(url).then(function (data) {
        _lazyloadCache[url] = data;
        return data;
    });
}

exports.lazyload = lazyload;
